import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { selectAccountId } from '@selectors'
import { useParams, useHistory } from 'react-router-dom'

import { SET_ENGAGEMENT_DETAIL_ID } from '@actions/types'

import Breadcrumb from '@components/breadcrumb/breadcrumb.component'
import EngagementDetailHeader from '@components/engagement-detail-header/engagement-detail-header.component'
import ResponsiveContainer from '@components/responsive-container/responsive-container.component'
import EngagementDetailListItem from '@components/engagement-detail-list-item/engagement-detail-list-item.component'
import Map from '@components/map/map.component'

import i18n from 'i18n-js'
import { USER, USERS } from '../../assets/i18n/strings'

import useStyles, { mapContainerStyle } from './engagement-detail.style'

const center = {
  lat: -31.56391,
  lng: 147.154312
}

const getKeyColor = index => {
  switch (index) {
  case 0:
    return 'FF0000'
  case 1:
    return '00FF00'
  case 2:
    return 'FFA500'
  case 3:
    return '800080'
  default:
    return 'FF0000'
  }
}

const EngageDetail = (props) => {
  const classes = useStyles(props)

  const dispatch = useDispatch()

  const { personalAccessCode, engagementId } = useParams()

  const history = useHistory()

  const accountId = useSelector(selectAccountId)

  const engageRef = `engage/${accountId}/cta`

  const engagements = useSelector(({ firestore: { ordered } }) => ordered[engageRef] && ordered[engageRef])

  const engagement = engagements?.find(({ id }) => id === engagementId)

  useEffect(() => {
    if (engagement) {
      dispatch({ type: SET_ENGAGEMENT_DETAIL_ID, payload: engagementId })
    }
  }, [dispatch, engagement, engagementId])

  if (!engagement) return null

  const { suggestions = [], no_sent: noSent } = engagement

  const noNoResponse = () => {
    let totalResponses = 0

    suggestions.forEach(suggestion => {
      const { no_responses: noResponses } = suggestion

      if (noResponses) totalResponses = totalResponses + noResponses
    })

    return noSent - totalResponses
  }

  const handleOnClick = (reply) => {
    const { cta_reference: ctaReference, reply_guid: replyGuid } = reply

    if (ctaReference) {
      history.push(`/${personalAccessCode}/engage/${ctaReference}`)
    } else {
      history.push(`/${personalAccessCode}/engage/${engagementId}/reply/${replyGuid}`)
    }
  }

  const locations = []

  suggestions.forEach((suggestion, index) => {
    const { users = [] } = suggestion

    users.forEach(user => {
      const { location } = user

      if (location) {
        const coords = Object.keys(location).map(key => location[key])
        const [lat, lng] = coords

        locations.push({
          lat,
          lng,
          color: getKeyColor(index)
        })
      }
    })
  })

  return (
    <div className={classes.container}>
      <Breadcrumb />
      <div className={classes.content}>
        <ResponsiveContainer className={classes.responsive}>
          <div className={classes.header}>
            <EngagementDetailHeader
              title={engagement.message_text}
              usersMessaged={`${noSent} ${noSent === 1 ? i18n.t(USER) : i18n.t(USERS)} Messaged`}
            />
          </div>
          <ul>
            {suggestions.map((suggestion, index) => (
              <EngagementDetailListItem
                key={`engage-suggestion-${index}`}
                index={index}
                noNoResponse={suggestion.type === 'no-response' ? noNoResponse() : null}
                noSent={noSent}
                onClick={handleOnClick}
                personalAccessCode={personalAccessCode}
                progressColor={getKeyColor(index)}
                suggestion={suggestion}
              />
            ))}
          </ul>
          {locations.length > 0 &&
            <Map
              center={center}
              locations={locations}
              mapContainerStyle={mapContainerStyle}
              zoom={3}
            />}
        </ResponsiveContainer>
      </div>
    </div>
  )
}

export default EngageDetail
